// =============================================================================
// features/sales/campaigns/wizard/cadence.ts — Validação pura da janela
// semanal da etapa 5 (F35-S08). Mesma regra de `CampaignWeeklyWindowSchema`
// (packages/shared-schemas/src/sales-campaigns.ts): HH:MM e start < end —
// reproduzida aqui só para dar feedback client-side ANTES do PATCH (a API
// continua sendo a fonte de verdade, revalida tudo de novo).
// =============================================================================

import type { CampaignWeeklyWindow, CampaignWindowDayKey } from '@elemento/shared-schemas';
import { CAMPAIGN_WINDOW_DAY_KEYS } from '@elemento/shared-schemas';

export const WEEKDAY_LABEL: Record<CampaignWindowDayKey, string> = {
  mon: 'Segunda',
  tue: 'Terça',
  wed: 'Quarta',
  thu: 'Quinta',
  fri: 'Sexta',
  sat: 'Sábado',
  sun: 'Domingo',
};

export const WEEKDAY_ORDER: CampaignWindowDayKey[] = [...CAMPAIGN_WINDOW_DAY_KEYS];

const TIME_HHMM_REGEX = /^([01]\d|2[0-3]):[0-5]\d$/;

export interface WeeklyWindowErrors {
  /** Uma mensagem por dia com erro — dias válidos/ausentes não aparecem aqui. */
  byDay: Partial<Record<CampaignWindowDayKey, string>>;
  /** `true` quando nenhum dia está configurado (campanha não fica pronta pra ativar). */
  empty: boolean;
}

export function validateWeeklyWindow(window: CampaignWeeklyWindow): WeeklyWindowErrors {
  const byDay: Partial<Record<CampaignWindowDayKey, string>> = {};

  for (const day of WEEKDAY_ORDER) {
    const w = window[day];
    if (!w) continue;
    if (!TIME_HHMM_REGEX.test(w.start) || !TIME_HHMM_REGEX.test(w.end)) {
      byDay[day] = 'Horário inválido — use HH:MM.';
      continue;
    }
    if (w.start >= w.end) {
      byDay[day] = 'O horário inicial precisa ser antes do final.';
    }
  }

  return { byDay, empty: Object.keys(window).length === 0 };
}
